import { apiPut } from "../utils";

// Where "show in matrix" leads once the cargo and vessel are set up.
export const MATRIX_PAGE = "/calculator";

// The guided flows, in the order a new user meets them.
// Completion is stored per user in auth.calcTours.<key> (synced to the backend).
export const GUIDES = {
  cargo: { label: "Create a cargo order", desc: "Enter the route, quantity and cargo details.", path: "/orders" },
  vessel: { label: "Add a vessel to your fleet", desc: "Choose a vessel with its open port and date.", path: "/vesselManager" },
  matrix: { label: "Add your cargo to the matrix", desc: "Complete the order's steps so it shows in the matrix.", path: "/orders" },
  view: { label: "Compare vessels in the matrix", desc: "Select a cargo, review each vessel and run the calculation.", path: MATRIX_PAGE },
};

const readJson = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "{}") || {};
  } catch (e) {
    return {};
  }
};

export const guideStorageKey = () => {
  const auth = readJson("auth");
  return "calc_onboarding:" + (auth.userId || auth._id || auth.email || "anonymous");
};

export const readGuideProgress = (key) => {
  const storageKey = guideStorageKey();
  let all = readJson(storageKey);
  if (!all.migrated) {
    const legacy = readJson("calc_tours");
    all = { ...legacy, ...all, migrated: true };
    // Old Skip wrote completed=true even at the first step. Preserve its position, not that flag.
    if (all.orders?.completed && all.orders.step < 7) {
      all.orders.completed = false;
      all.matrix = { ...(all.matrix || {}), done: false };
    }
    if (all.vessel_tab?.isTourCompleted && all.vessel_tab.currentStepIndex < 11) all.vessel_tab.isTourCompleted = false;
    localStorage.setItem(storageKey, JSON.stringify(all));
    localStorage.removeItem("calc_tours");
  }
  return all[key] || {};
};

export const saveGuideProgress = (key, updates) => {
  readGuideProgress(key);
  const storageKey = guideStorageKey();
  const all = readJson(storageKey);
  all[key] = { ...(all[key] || {}), ...updates };
  localStorage.setItem(storageKey, JSON.stringify(all));
};

export const isGuideDone = (key) => {
  const progress = readGuideProgress(key);
  if (progress.done !== undefined) return progress.done === true;
  const legacy = readGuideProgress(key === "cargo" ? "orders" : "vessel_tab");
  if (key === "cargo" && legacy.completed === false) return false;
  if (key === "vessel" && legacy.isTourCompleted === false) return false;
  return readJson("auth").calcTours?.[key] === true;
};

export const markGuideDone = (key) => {
  if (readGuideProgress(key).done === true) return;
  saveGuideProgress(key, { done: true });
  const auth = readJson("auth");
  auth.calcTours = { ...(auth.calcTours || {}), [key]: true };
  localStorage.setItem("auth", JSON.stringify(auth));
  apiPut("/api/profileDetails", { calcTours: { [key]: true } }).catch((err) =>
    console.error(`Failed to sync ${key} guide completion:`, err)
  );
};

// Manual / suggested start: leaves a request for the page that owns the guide, then goes there.
// The owner page calls takeGuideRequest on mount and on the "guide:request" event.
export const requestGuide = (key, history) => {
  localStorage.setItem(guideStorageKey() + ":request", key);
  window.dispatchEvent(new CustomEvent("guide:request"));
  if (history && history.location.pathname !== GUIDES[key].path) history.push(GUIDES[key].path);
};

export const hasGuideRequest = (key) => localStorage.getItem(guideStorageKey() + ":request") === key;

export const takeGuideRequest = (key) => {
  if (localStorage.getItem(guideStorageKey() + ":request") !== key) return false;
  localStorage.removeItem(guideStorageKey() + ":request");
  return true;
};
